export default __webpack_public_path__ + "static/media/hackathon-nasa.fc848a8b.png";